<template>
<div class="chapter">
<div class="inner_page">
<div id="V4037epub-2.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CT" id="toc_marker-3"><span class="char-style-override-4">Second <br/>Person<br/>Singular</span></p>
<p class="BT-1st-para para-style-override-3"><span class="char-style-override-5">Sayed Kashua</span></p>
<p class="A-Head para-style-override-4"><span class="char-style-override-6">Translated from the Hebrew <br/>by Mitch Ginsburg</span></p>
<p class="BT-1st-para para-style-override-3"><img alt="V-1.tif" class="image" height="24" src="images/V-1_fmt.png" width="27"/></p>
<p class="BT-1st-para para-style-override-2">Grove Press</p>
<p class="BT-1st-para para-style-override-2"><span class="char-style-override-7">an imprint of Grove/Atlantic, Inc.</span></p>
<p class="BT-1st-para para-style-override-2"><span class="char-style-override-3">New York</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// V4037epub-2.vue?232d9496